import axios, { AxiosResponse } from "axios";
import { getErrorMessage } from '../locales/translationUtils';

interface ApiResponse<T> {
    success: boolean;
    message: string;
    data: T;
}

interface User {
    username: string;
    password: string;
    id: number;
    rememberMe: boolean;
}

interface UserData {
    username: string;
    permission: string;
    id: number;
}

const baseUrl: string | undefined = process.env.REACT_APP_BACK_END_AUTH_API_URL;
if (!baseUrl) throw new Error(getErrorMessage('missingEnvVariableError'));

export const login = async (data: User): Promise<UserData> => {
    const url = `${baseUrl}Autenticacao/login`;

    try {
        const response: AxiosResponse<ApiResponse<UserData>> = await axios.post(url, {
            username: data.username,
            password: data.password,
        }, { withCredentials: true });

        if (response.status === 200) {
            return response.data.data;
        } else {
            throw new Error(getErrorMessage("loginFailedError"));
        }
    } catch (error: any) {
        throw error.response ? error.response : error;
    }
};

export const validateSessionService = async (): Promise<User | null> => {
    const url = `${baseUrl}Autenticacao/validateSession`;

    try {
        const response: AxiosResponse<ApiResponse<User>> = await axios.get(url, { withCredentials: true });

        return response.data.data; 
    } catch (error: any) {
        return null; 
    }
};

